// src/components/ProfileDropdown.js

import React from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../features/authSlice'; // Import the logout action
import { selectUserData, selectUserStatus } from '../features/userSlice';

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Selectors to get user data (already fetched in Layout.js)
  const userData = useSelector(selectUserData);
  const userStatus = useSelector(selectUserStatus);
  const unitsStatus = useSelector((state) => state.units.status);
  const unitsError = useSelector((state) => state.units.error);

  // No data fetching here - Layout.js handles all fetching centrally

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  // Generate initials from first and last name
  const userInitials = userData
    ? `${userData.first_name.charAt(0)}${userData.last_name.charAt(0)}`
    : '';

  // Full name
  const userName = userData
    ? `${userData.first_name} ${userData.last_name}`
    : '';

  if (userStatus === 'loading' || unitsStatus === 'loading') {
    return (
      <Spinner animation="border" role="status" size="sm">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  if (userStatus === 'failed') {
    return <div className="text-danger">Error: Could not load user data</div>;
  }

  if (unitsStatus === 'failed') {
    return <div className="text-danger">Error: {unitsError}</div>;
  }

  return (
    <Dropdown className="d-flex align-items-center">
      <Dropdown.Toggle
        as="div"
        id="profile-dropdown"
        className="d-flex align-items-center"
        style={{ cursor: 'pointer' }}
      >
        <div className="header-avatar">
          {userInitials}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="header-dropdown-menu dropdown-menu-end">
        {/* User Info */}
        <div className="header-dropdown-user-info">
          <div className="header-dropdown-user-name">{userName}</div>
          <div className="header-dropdown-user-role">{userData?.role?.role_name}</div>
        </div>
        
        <Dropdown.Divider />
        
        {/* Company Info */}
        <div className="header-dropdown-company-info">
          <div className="header-dropdown-label">Unternehmen</div>
          <div className="header-dropdown-value">{userData?.company}</div>
        </div>
        
        <Dropdown.Divider />
        
        {/* Settings Link */}
        <Dropdown.Item
          href="/settings"
          className="d-flex align-items-center"
        >
          <FaUser size={16} className="me-3" />
          Einstellungen
        </Dropdown.Item>
        
        <Dropdown.Divider />
        
        {/* Logout */}
        <Dropdown.Item
          onClick={handleLogout}
          className="d-flex align-items-center text-danger"
        >
          <FaSignOutAlt size={16} className="me-3" />
          Ausloggen
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
